export const ImageOptionsKey = {
  DEFAULT: 'default',
  UPLOAD: 'uploadlocal',
  FACEBOOKIMPORT: 'fbimport',
};
